import { useState } from "react"
import routes from "web/routes/constants"

export default function MarketViewableSelector({
  currentView,
  parentSubjectSlug,
  subjectType,
  topicName,
  viewMode,
}) {
  const [selectedOption, setSelectedOption] = useState(currentView.id)

  function handleChange(event) {
    setSelectedOption(event.target.value)

    const viewable = currentView.selectable_viewables.find(
      (viewable) => viewable.id.toString() === event.target.value
    )

    const viewableId = viewable.viewable_type === "view" ? viewable.id : null
    const viewModeString =
      viewMode === undefined || viewMode === null || viewMode === ""
        ? ""
        : `/${viewMode}`

    window.Turbo.visit(
      routes.market_view(
        parentSubjectSlug,
        subjectType,
        viewableId,
        topicName
      ) + viewModeString
    )
  }

  return (
    <div className="w-56">
      <select
        value={selectedOption}
        onChange={handleChange}
        className="w-full text-ellipsis rounded-md border-gray-300 text-black shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
        title={currentView.name}
      >
        {currentView.selectable_viewables.map((option, index) => (
          <option key={index} value={option.id}>
            {option.name === "All" ? "Default" : option.name}
          </option>
        ))}
      </select>
    </div>
  )
}
